/*
  Sepete ekleme sonrası teklif.

  Ürün sayfası sepete ekleyince `nowa:offer:ask` olayını yayınlıyor ve çekmeceyi
  AÇMIYOR. Bu eleman teklifi gösteriyor; kullanıcı ne yaparsa yapsın sonunda
  `nowa:cart:open` yayınlanıp çekmece açılıyor. Böylece teklif akışı kesmiyor,
  araya giriyor.

  Gösterilmeyecek durumlarda (kapalı, daha önce gösterilmiş) olay geldiği anda
  çekmeceyi açıyoruz — müşteri bekletilmiyor.
*/
class NowaOffer extends HTMLElement {
  connectedCallback() {
    this.qty = 1;
    this.pending = null;
    this.routes = window.Shopify?.routes?.root || '/';

    this.addEventListener('click', this.onClick);
    document.addEventListener('nowa:offer:ask', this.onAsk);
  }

  disconnectedCallback() {
    document.removeEventListener('nowa:offer:ask', this.onAsk);
    this.stopClock();
  }

  get storageKey() {
    return `nowa:${this.dataset.key || 'offer'}`;
  }

  /*
    Gösterim sıklığı. Tek bir "bir kez" anahtarı yerine dört mod:
    - always  : her sepete eklemede (test için)
    - session : sekme kapanınca sıfırlanır
    - daily   : 24 saatte bir
    - once    : ziyaretçi başına bir kez

    `daily` ve `once` için zaman damgası yazılıyor; boolean yerine damga
    kullanınca mod değiştiğinde eski kayıt hâlâ anlamlı oluyor.
  */
  get frequency() {
    return this.dataset.frequency || 'session';
  }

  get store() {
    try {
      return this.frequency === 'session' ? sessionStorage : localStorage;
    } catch (e) {
      return null;
    }
  }

  gosterildiMi() {
    if (this.frequency === 'always') return false;
    const s = this.store;
    if (!s) return false;
    try {
      const damga = Number(s.getItem(this.storageKey));
      if (!damga) return false;
      if (this.frequency === 'daily') {
        return Date.now() - damga < 24 * 60 * 60 * 1000;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  gosterildiYaz() {
    if (this.frequency === 'always') return;
    const s = this.store;
    if (!s) return;
    try {
      s.setItem(this.storageKey, String(Date.now()));
    } catch (e) {
      /* gizli sekmede yazılamaz — teklif yine çalışsın */
    }
  }

  onAsk = (event) => {
    this.pending = event.detail || {};
    if (this.gosterildiMi()) {
      this.devamEt();
      return;
    }
    this.ac();
  };

  ac() {
    this.gosterildiYaz();
    this.hidden = false;
    document.body.classList.add('nowa-offer-open');
    this.startClock();
    this.querySelector('[data-nowa-offer-accept]')?.focus();
  }

  /** Teklifi kapatır ve akışı sepete devreder. */
  devamEt() {
    this.stopClock();
    this.hidden = true;
    document.body.classList.remove('nowa-offer-open');
    const detail = this.pending || {};
    this.pending = null;
    document.dispatchEvent(new CustomEvent('nowa:cart:open', { detail }));
  }

  /* ---------- Galeri ---------- */

  /*
    Küçük resimler ve oklar aynı aktif indeksi paylaşıyor. Ok basınca ilgili
    küçük resim işaretleniyor ve şeritte görünür hâle getiriliyor. Uçlarda
    dönüyor — dar pencerede tıkanma olmasın.
  */
  gorseliGoster(indeks) {
    const thumbs = [...this.querySelectorAll('[data-nowa-offer-thumb]')];
    const stage = this.querySelector('[data-nowa-offer-stage]');
    if (!stage || !thumbs.length) return;
    const n = thumbs.length;
    const i = ((indeks % n) + n) % n;
    stage.src = thumbs[i].dataset.full;
    thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
    thumbs[i].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
  }

  onClick = (event) => {
    const { target } = event;

    const thumb = target.closest('[data-nowa-offer-thumb]');
    if (thumb) {
      event.preventDefault();
      const hepsi = [...this.querySelectorAll('[data-nowa-offer-thumb]')];
      this.gorseliGoster(hepsi.indexOf(thumb));
      return;
    }

    const ok = target.closest('[data-nowa-offer-gallery]');
    if (ok) {
      event.preventDefault();
      const hepsi = [...this.querySelectorAll('[data-nowa-offer-thumb]')];
      const simdi = hepsi.findIndex((t) => t.classList.contains('is-active'));
      this.gorseliGoster((simdi < 0 ? 0 : simdi) + Number(ok.dataset.nowaOfferGallery));
      return;
    }

    if (target.closest('[data-nowa-offer-dismiss]')) {
      event.preventDefault();
      this.devamEt();
      return;
    }

    const step = target.closest('[data-nowa-offer-step]');
    if (step) {
      event.preventDefault();
      this.qty = Math.max(1, this.qty + Number(step.dataset.nowaOfferStep));
      const el = this.querySelector('[data-nowa-offer-qty]');
      if (el) el.textContent = this.qty;
      return;
    }

    if (target.closest('[data-nowa-offer-accept]')) {
      event.preventDefault();
      this.kabulEt(target.closest('[data-nowa-offer-accept]'));
    }
  };

  async kabulEt(button) {
    const id = Number(this.dataset.variantId);
    if (!id) return this.devamEt();

    const etiket = button.textContent;
    button.disabled = true;
    button.textContent = '…';

    try {
      const res = await fetch(`${this.routes}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: this.qty }],
          sections: 'nowa-cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'offer add failed');
      // Çekmece taze HTML ile açılsın
      this.pending = { ...(this.pending || {}), ...data };
    } catch (e) {
      console.error('[nowa-offer] eklenemedi:', e);
    } finally {
      button.disabled = false;
      button.textContent = etiket;
      this.devamEt();
    }
  }

  /* ---------- Geri sayım ---------- */

  startClock() {
    const dakika = Number(this.dataset.minutes) || 0;
    const el = this.querySelector('[data-nowa-offer-clock]');
    if (!dakika || !el) return;

    let kalan = dakika * 60;
    const yaz = () => {
      const d = String(Math.floor(kalan / 60)).padStart(2, '0');
      const s = String(kalan % 60).padStart(2, '0');
      el.textContent = `${d}:${s}`;
    };
    yaz();
    this.timer = setInterval(() => {
      kalan -= 1;
      if (kalan <= 0) {
        this.stopClock();
        el.textContent = '00:00';
        return;
      }
      yaz();
    }, 1000);
  }

  stopClock() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('nowa-offer')) {
  customElements.define('nowa-offer', NowaOffer);
}
